import { render, staticRenderFns } from "./EditLight.vue?vue&type=template&id=c80acd76&"
import script from "./EditLight.vue?vue&type=script&lang=ts&"
export * from "./EditLight.vue?vue&type=script&lang=ts&"
import style0 from "./EditLight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports